import React from 'react';

interface IconStepMatchProps {
  className?: string;
  size?: number;
}

export const IconStepMatch: React.FC<IconStepMatchProps> = ({ className = '', size = 40 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z"
        fill="#FFBF58"
      />
      <path
        d="M13.3332 21.6662C13.1755 21.6668 13.0209 21.6226 12.8874 21.5387C12.7538 21.4549 12.6468 21.3349 12.5787 21.1926C12.5106 21.0504 12.4843 20.8917 12.5028 20.7351C12.5213 20.5785 12.5839 20.4304 12.6832 20.3079L20.9332 11.8079C20.9951 11.7365 21.0795 11.6882 21.1724 11.671C21.2653 11.6538 21.3613 11.6687 21.4447 11.7133C21.528 11.7579 21.5937 11.8295 21.631 11.9163C21.6683 12.0032 21.675 12.1001 21.6499 12.1912L20.0499 17.2079C20.0027 17.3342 19.9869 17.47 20.0037 17.6037C20.0206 17.7375 20.0696 17.8651 20.1467 17.9758C20.2237 18.0864 20.3264 18.1767 20.446 18.2389C20.5656 18.3011 20.6984 18.3333 20.8332 18.3329H26.6666C26.8243 18.3324 26.9789 18.3766 27.1124 18.4604C27.246 18.5443 27.3531 18.6643 27.4211 18.8065C27.4892 18.9488 27.5155 19.1074 27.497 19.264C27.4785 19.4206 27.4159 19.5688 27.3166 19.6912L19.0666 28.1912C19.0047 28.2627 18.9204 28.3109 18.8274 28.3281C18.7345 28.3453 18.6385 28.3304 18.5551 28.2858C18.4718 28.2412 18.4061 28.1697 18.3688 28.0828C18.3315 27.996 18.3248 27.899 18.3499 27.8079L19.9499 22.7912C19.9971 22.665 20.0129 22.5291 19.9961 22.3954C19.9792 22.2617 19.9302 22.134 19.8532 22.0234C19.7761 21.9128 19.6734 21.8225 19.5538 21.7603C19.4343 21.6981 19.3014 21.6658 19.1666 21.6662H13.3332Z"
        stroke="white"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default IconStepMatch;
